

const PageNotFound:React.FC=()=>{

    return(
        <>
         page not found
        </>
    )
}

export default PageNotFound;